"use strict";
var $ = require('jquery');
function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = _interopRequireDefault(require("../js-utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Polyfills for IE 11
if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();
/**
 * Cookie Consent
 *
 * Usage via global event listener:
 * window.addEventListener('app.cookieConsent.onChange', function(event) {
 *   console.log('The cookie consent has been updated.', app.cookies.cookieConsent.types);
 * });
 *
 * Marketing example:
 * window.addEventListener('app.cookieConsent.onChange', function(event) {
 *   if (app.cookies.cookieConsent.types.marketing) {
 *     // Embed tracking code here
 *   }
 * });
 *
 * Open the cookie consent layer via a link with the hashtag "#cookie-consent":
 * <a href="#cookie-consent">Update cookie settings</a>
 *
 * or via Markdown
 * [Update cookie settings](#cookie-consent)
 *
 * @class
 * @constructor
 * @public
 */


var CookieConsent = /*#__PURE__*/function () {
  /**
   * Constructor
   * @returns {class}
   */
  function CookieConsent() {
    _classCallCheck(this, CookieConsent);

    !app.cookies && console.error('Application: window.app.cookies object required.');
    this.cookieConsent = document.getElementById('cookie-consent--js');
    this.saveButtons = this.cookieConsent.querySelectorAll('#cookie-consent-save, a');
    this.acceptButton = document.getElementById('cookie-consent-accept');
    this.openTrigger = document.querySelectorAll('[href="#cookie-consent"]');

    if (!this.cookieConsent || !app.cookies.cookieConsent) {
      return;
    } // Engage engines


    this.init();
  }
  /**
   * Initialize the component
   * @returns {void}
   */


  _createClass(CookieConsent, [{
    key: "init",
    value: function init() {
      if (_utils.default.cookie.get(app.cookies.cookieConsent.name)) {
        app.cookies.cookieConsent.types = JSON.parse(_utils.default.cookie.get(app.cookies.cookieConsent.name));
        this.fireCustomEvent();
      } else {
        app.cookies.cookieConsent.types = {};
        this.openCookieConsent();
      }

      this.addEventListeners();
      return this;
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this = this;

      this.saveButtons.forEach(function (saveButton) {
        saveButton.addEventListener('click', _this.onSaveButtonClick.bind(_this));
      });
      this.acceptButton.addEventListener('click', this.onAcceptButtonClick.bind(this));
      this.openTrigger.forEach(function (trigger) {
        trigger.addEventListener('click', _this.onOpenTrigger.bind(_this));
      });
    }
  }, {
    key: "onSaveButtonClick",
    value: function onSaveButtonClick(event) {
      this.setCookieConsent();
      this.closeCookieConsent();
    }
  }, {
    key: "onAcceptButtonClick",
    value: function onAcceptButtonClick(event) {
      this.setCookieConsent('all'
          /* Select all checkboxes */
      );
      this.closeCookieConsent();
    }
  }, {
    key: "onOpenTrigger",
    value: function onOpenTrigger(event) {
      event.preventDefault();
      this.openCookieConsent();
    }
  }, {
    key: "openCookieConsent",
    value: function openCookieConsent() {
      this.cookieConsent.classList.add('is-active');
      this.updateCheckboxes('update');
    }
  }, {
    key: "closeCookieConsent",
    value: function closeCookieConsent() {
      this.cookieConsent.classList.remove('is-active');
    }
  }, {
    key: "fireCustomEvent",
    value: function fireCustomEvent() {
      window.dispatchEvent(new CustomEvent('app.cookieConsent.onChange'));
    }
  }, {
    key: "setCookieConsent",
    value: function setCookieConsent(selectCheckboxes) {
      this.updateCheckboxes(selectCheckboxes);
      this.fireCustomEvent(); // Set cookie

      _utils.default.cookie.set(app.cookies.cookieConsent.name, JSON.stringify(app.cookies.cookieConsent.types), app.cookies.cookieConsent.expires, app.cookies.cookieConsent.path);
    }
  }, {
    key: "updateCheckboxes",
    value: function updateCheckboxes(selectCheckboxes) {
      var form = this.cookieConsent;

      for (var i = 0; i < form.elements.length; i++) {
        if (form.elements[i].type === 'checkbox') {
          if (selectCheckboxes === 'all') {
            form.elements[i].checked = true;
          } // Populate checkboxes


          if (selectCheckboxes === 'update' && !form.elements[i].disabled) {
            form.elements[i].checked = app.cookies.cookieConsent.types[form.elements[i].value];
          } // Store values


          app.cookies.cookieConsent.types[form.elements[i].value] = form.elements[i].checked;
        }
      }
    }
  }]);

  return CookieConsent;
}();

;

function init() {
  /*document.addEventListener('DOMContentLoaded', function () {*/
  $(document).ready(function() {
    new CookieConsent();
  });


}

var _default = {
  init: init
};
module.exports = _default;